import { render } from "./despesas-orcamentaria.vue?vue&type=template&id=dc43d35e&scoped=true"
import script from "./despesas-orcamentaria.vue?vue&type=script&lang=js"
export * from "./despesas-orcamentaria.vue?vue&type=script&lang=js"

import "./despesas-orcamentaria.vue?vue&type=style&index=0&id=dc43d35e&lang=scss&scoped=true"

import exportComponent from "/run/media/ctis-dev/developer/WorkSpaceFront/transparencia-ui/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-dc43d35e"]])

export default __exports__